import $ from "jquery";
import * as d3 from "d3";
import {DEBUG} from "src/utils/controllerAdapterForOfferPage";

export class LabelPage {

    constructor(container, labels) {
        this.height = 297;
        this.width = 210;

        this.cols = 8;
        this.rows = 5;

        this.margin = {
            top: 10,
            right: 5,
            bottom: 2,
            left: 5,
        }

        const xMargin = 0;
        const yMargin = 5;
        const completeLabelHeight = (this.height - this.margin.top - this.margin.bottom) / this.rows - yMargin + yMargin / this.rows;
        const unusedLabelHeight = 40;

        this.labelSizes = {
            height: completeLabelHeight - unusedLabelHeight,
            width: (this.width - this.margin.left - this.margin.right) / this.cols - 2 * xMargin,
            xMargin,
            yMargin,
            unusedLabelHeight,
            fontSize: 3
        }

        this.labelSpace = 10;
        this.spaceBtwn = 50;
        /**
         * The jQuery selected container where we will place the pinout pages.
         * @type {JQuery<HTMLElement>}
         */
        this.$container = container;

        this.$container.empty();

        this.labelPages = this.generatePages(labels);


        /**
         * The DOM Element where we will place the pinout pages.
         */
        this.containerNode = this.$container[0];

        this.debug = DEBUG;
    }

    resultToContainer() {
        const tv = this;
        /* console.log(this.labelPages); */
        this.labelPages.forEach(function (page) {
            let pageCont = d3.select(tv.containerNode)
                .append('div')
                .append("svg")
                .attr("width", '100%')
                .attr("viewBox", `0 0 ${tv.width} ${tv.height}`)
                .attr("class", "label-page lightshadow")
                .style("margin-bottom", 10)
                .append("g");

            if (tv.debug) {
                pageCont.append('rect')
                  .attr('x', 0)
                  .attr('y', 0)
                  .attr('width', tv.width)
                  .attr('height', tv.height)
                  .attr('stroke', 'pink')
                  .attr('stroke-width', 0.25)
                  .attr('rx', 5)
                  .attr('ry', 5)
                  .attr('fill-opacity', 0)
            }

            page.forEach(function (row, rowIdx) {
                row.forEach(function (elem, colIdx) {
                    const topLeftX = tv.margin.left + colIdx * (tv.labelSizes.width + tv.labelSizes.xMargin) + (colIdx + 1) * tv.labelSizes.xMargin;
                    const topLeftY = tv.margin.top + rowIdx * (tv.labelSizes.height + tv.labelSizes.yMargin + tv.labelSizes.unusedLabelHeight);
                    if (tv.debug) {
                        pageCont.append('rect')
                          .attr('x', topLeftX)
                          .attr('y', topLeftY)
                          .attr('width', tv.labelSizes.width)
                          .attr('height', tv.labelSizes.height)
                          .attr('stroke', 'pink')
                          .attr('stroke-width', 0.25)
                          .attr('fill-opacity', 0);

                        pageCont.append('rect')
                          .attr('x', topLeftX)
                          .attr('y', topLeftY + tv.labelSizes.height)
                          .attr('width', tv.labelSizes.width)
                          .attr('height', tv.labelSizes.unusedLabelHeight)
                          .attr('stroke', 'pink')
                          .attr('stroke-width', 0.25)
                          .attr('fill-opacity', 0)
                    }
                    pageCont.append("text")
                      .attr('x', topLeftX + tv.labelSizes.width / 2)
                      .attr('y', topLeftY + tv.labelSizes.height / 2 + tv.labelSizes.fontSize / 2)
                      .attr('fill', 'black')
                      .attr('text-anchor', 'middle')
                      .attr('font-size', tv.labelSizes.fontSize)
                      .text(elem);
                });
            });
        });
        $('.label-page').each(function () {
            $(this).height($(this).width() * 842 / 595);
        });
    }

    chunkArray(myArray, chunk_size) {
        let index = 0;
        const arrayLength = myArray.length;
        const tempArray = [];

        for (index = 0; index < arrayLength; index += chunk_size) {
            const myChunk = myArray.slice(index, index + chunk_size);
            tempArray.push(myChunk);
        }

        return tempArray;
    }

    /**
     * 
     * @param {string[]} labels 
     * @returns {string[][][]}
     */
    generatePages(labels) {
        const rows = this.chunkArray(labels, this.cols);
        const pages = this.chunkArray(rows, this.rows);
        return pages;
    }
}